import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";
import { Country, State, City } from "country-state-city";
import Select from "react-select";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import axios from "axios";
import Swal from "sweetalert2";
import "react-responsive-modal/styles.css";
import { Modal } from "react-responsive-modal";
import { Container, Button, Link } from 'react-floating-action-button'

const Inquiry = () => {
  const [open, setOpen] = useState(false);

  const onOpenModal = () => setOpen(true);
  const onCloseModal = () => setOpen(false);
  const [selectedCountry, setSelectedCountry] = useState("");
  const [selectedState, setSelectedState] = useState("");
  const [selectedCity, setSelectedCity] = useState("");
  const [countryDropdownOpen, setCountryDropdownOpen] = useState(false); // State variable for country dropdown visibility
  const [stateDropdownOpen, setStateDropdownOpen] = useState(false); // State variable for state dropdown visibility
  const [cityDropdownOpen, setCityDropdownOpen] = useState(false); // State variable for state dropdown visibility

  const handleCountryChange = (selectedOption) => {
    setSelectedCountry(selectedOption);
    setSelectedState("");
    setSelectedCity("");
  };

  const handleStateChange = (selectedOption) => {
    setSelectedState(selectedOption);
    setSelectedCity("");
  };

  const handleCityChange = (selectedOption) => {
    setSelectedCity(selectedOption);
  };

  const toggleCountryDropdown = () => {
    setCountryDropdownOpen(!countryDropdownOpen);
  };

  const toggleStateDropdown = () => {
    setCountryDropdownOpen(false);
    setStateDropdownOpen(!stateDropdownOpen);
    console.log(!stateDropdownOpen, "stateDropdownOpen");
  };

  const toggleCityDropdown = () => {
    setCountryDropdownOpen(false);
    setStateDropdownOpen(false);
    setCityDropdownOpen(!cityDropdownOpen);
    console.log(!cityDropdownOpen, "cityDropdownOpen");
  };

  const toggleCityCloseDropdown = () => {
    setCountryDropdownOpen(false);
    setStateDropdownOpen(false);
    setCityDropdownOpen(false);
  };

  // Fetch the list of countries
  const countryOptions = Country.getAllCountries().map((country) => ({
    label: country.name,
    value: country.isoCode,
  }));

  // Fetch the list of states based on the selected country
  const stateOptions = selectedCountry
    ? State.getStatesOfCountry(selectedCountry.value).map((state) => ({
        label: state.name,
        value: state.isoCode,
      }))
    : [];

  // Fetch the list of cities based on the selected state
  const cityOptions = selectedState
    ? City.getCitiesOfState(selectedCountry.value, selectedState.value).map(
        (city) => ({
          label: city.name,
          value: city.name,
        })
      )
    : [];

  const initialValues = {
    name: "",
    email: "",
    phone: "",
    who_are_you: "",
    message: "",
    country: "",
    state: "",
    city: "",
  };

  const validationSchema = Yup.object().shape({
    name: Yup.string().required("Name is required"),
    email: Yup.string().email("Invalid email"),
    phone: Yup.string().required("Mobile is required"),
    who_are_you: Yup.string().required("Please select a Your profession"),
    message: Yup.string(),
  });

  const dataSubmit = async (values) => {
    try {
      // Add the selected country, state, and city to the values object
      values.country = selectedCountry ? selectedCountry.label : "";
      values.state = selectedState ? selectedState.label : "";
      values.city = selectedCity ? selectedCity.label : "";

      const response = await axios.post(
        "https://mahalaxmioil.3waysource.com/api.php",
        values
      );
      console.log(response.data); // Handle the API response as needed
      // Display SweetAlert on success
      Swal.fire({
        position: "center",
        icon: "success",
        title: "Your data submitted successfully",
        showConfirmButton: false,
        timer: 2500,
      });

      // Close the modal
      onCloseModal();
    } catch (error) {
      console.error(error);
    }
  };

  const [showIcons, setShowIcons] = useState(false);

  const handleFABClick = () => {
    setShowIcons(!showIcons);
   
  };

  return (
    <section>
      {/* <span className="email-icon flex" onClick={onOpenModal}>
        <FontAwesomeIcon icon={faEnvelope} size="2x" style={{ color: "red" }} />
        <p
          style={{ marginTop: "0px", marginBottom: "0px" }}
          className="hide-on-mobile "
        >
          Send{" "}
        </p>
        <p
          style={{ marginTop: "0px", marginBottom: "0px" }}
          className="hide-on-mobile "
        >
          Inquiry
        </p>
      </span> */}
      {showIcons && (
        <div className="icon-container">
          {/* WhatsApp Icon */}
          <a
            className="icon-link"
            href="https://api.whatsapp.com/send?phone=1234567890"
            target="_blank"
            rel="noopener noreferrer"
          >
            <i className="fab fa-whatsapp"></i>
          </a>
          {/* Email Icon */}
          <a
            className="icon-link"
            href="mailto:example@example.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            <i className="far fa-envelope"></i>
          </a>
        </div>
      )}
      {/* <button className="floating-action-button" onClick={handleFABClick}>
        <i className="fas fa-plus"></i>
      </button> */}
       <Container>
       <Link href="tel:+917575094646"
                tooltip="Call"
                icon="fas fa-phone" />
            <Link 
            href="/contact"
                tooltip="Send Inquiry"
                icon="fas fa-envelope" />
            <Link href="https://wa.me/+917575094646" target="_blank"
                tooltip="Whatsapp"
                icon="fa fa-whatsapp" />
                
            <Button
                tooltip="Get in touch"
                icon="fas fa-comment-alt"
                rotate={false}
                 />
        </Container>
      

        <Modal open={open} onClose={onCloseModal} center>
                        <Formik
                          initialValues={{ initialValues }}
                          validationSchema={validationSchema}
                          onSubmit={(values) => {
                            dataSubmit(values);
                          }}
                        >
                          {({
                            values,
                            errors,
                            touched,
                            handleChange,
                            handleBlur,
                            handleSubmit,
                            isSubmitting,
                            /* and other goodies */
                          }) => (
                            <form
                              className="custom-form"
                              onSubmit={handleSubmit}
                            >
                              <h1 className="sml-h1">Enter Your Details</h1>
                              <fieldset>
                             
                                <label htmlFor="name">Name:</label>
                                <input
                                  name="name"
                                  value={values.name}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  id="name"
                                  placeholder="Name *"
                                  type="text"
                                  className={
                                    touched.name && errors.name ? "error" : ""
                                  }
                                />
                                {touched.name && errors.name && (
                                  <p className="error-message">{errors.name}</p>
                                )}

                                <label htmlFor="phone">Mobile:</label>
                                <input
                                  name="phone"
                                  value={values.phone}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  id="phone"
                                  placeholder="Mobile *"
                                  type="tel"
                                  className={
                                    touched.phone && errors.phone ? "error" : ""
                                  }
                                />
                                {touched.phone && errors.phone && (
                                  <p className="error-message">
                                    {errors.phone}
                                  </p>
                                )}

                                <label htmlFor="email">Email:</label>
                                <input
                                  name="email"
                                  value={values.email}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  id="email"
                                  placeholder="Email *"
                                  type="email"
                                  className={
                                    touched.email && errors.email ? "error" : ""
                                  }
                                />
                                {touched.email && errors.email && (
                                  <p className="error-message">
                                    {errors.email}
                                  </p>
                                )}

                                <label htmlFor="who_are_you">
                                  Who Are You:
                                </label>
                                <select
                                  name="who_are_you"
                                  id="who_are_you"
                                  value={values.who_are_you}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  className={
                                    touched.who_are_you && errors.who_are_you
                                      ? "error"
                                      : ""
                                  }
                                >
                                  <option value="">Select</option>
                                  <option value="Farmer">Farmer</option>
                                  <option value="Trader">Trader</option>
                                  <option value="Wholeseller">
                                    Wholeseller
                                  </option>
                                  <option value="Other">Other</option>
                                </select>
                                {touched.who_are_you && errors.who_are_you && (
                                  <p className="error-message">
                                    {errors.who_are_you}
                                  </p>
                                )}

                                <label>Message:</label>
                                <input
                                  name="message"
                                  id="message"
                                  value={values.message}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  placeholder="Message *"
                                  type="text"
                                  className={
                                    touched.message && errors.message
                                      ? "error"
                                      : ""
                                  }
                                />
                                {touched.message && errors.message && (
                                  <p className="error-message">
                                    {errors.message}
                                  </p>
                                )}
                                <label>Country</label>
                                <Select
                                  options={countryOptions}
                                  value={selectedCountry}
                                  onChange={handleCountryChange}
                                  onMenuOpen={toggleCountryDropdown}
                                  onMenuClose={toggleCountryDropdown}
                                />

                                <label>State</label>
                                <Select
                                  options={stateOptions}
                                  value={selectedState}
                                  onChange={handleStateChange}
                                  isDisabled={!selectedCountry}
                                  onMenuOpen={toggleStateDropdown}
                                  onMenuClose={toggleStateDropdown}
                                />

                                <label>City</label>
                                <Select
                                  options={cityOptions}
                                  value={selectedCity}
                                  onChange={handleCityChange}
                                  isDisabled={!selectedState}
                                  onMenuOpen={toggleCityDropdown}
                                  onMenuClose={toggleCityCloseDropdown}
                                />
                              </fieldset>

                              <p
                                style={{
                                  color: "red",
                                  margin: "20px",
                                  marginTop: "0px",
                                }}
                              ></p>

                              {!countryDropdownOpen &&
                                !stateDropdownOpen &&
                                !cityDropdownOpen && (
                                  <button
                                    onClick={handleSubmit}
                                    className="site-button-secondry btn-animate-one"
                                  >
                                    Send Inquiry
                                  </button>
                                )}
                            </form>
                          )}
                        </Formik>
                      </Modal>
    </section>
  );
};

export default Inquiry;
